









import { Component, Vue, Prop} from 'vue-property-decorator'
import {Dialog} from 'vant'
import { deleteRecord, handleCustomTrigger } from '@/apis/sheet'
import { cloneDeep } from 'lodash'
import { Toast } from 'vant'
import widget from '../widget/widgetInRecord'
@Component({
  name: 'moreOprate',
  components: {
    widget
  }
})
export default class extends Vue {
  @Prop() public worksheetId!: string
  @Prop() public recordId!: string
  @Prop() public customTriggerProperties!: any
  @Prop({default: () => []}) public operateArr!: any
  @Prop({default: () => void 0}) public triggerBtnForm!: any
  @Prop({default: false}) public canDelete!: boolean
  @Prop() public processId!: string
  private operateType = ['log', 'discussion', 'track']
  private actionShow = false
  private get actions () {
    let customTrigger: any = []
    if (this.customTriggerProperties && this.customTriggerProperties.length !== 0) {
      customTrigger = cloneDeep(this.customTriggerProperties)
      customTrigger.map(item => {
        item.name = item.customTriggerButtonProperty.buttonName
        item.key = 'customTrigger'
      })
    }

    return [...this.operateArr, ...customTrigger]
  }
  public open () {
    this.actionShow = true
  }
  public async fetchCustomTrigger (row, hiddenTip) {
    let data = {
      flowId: row.flowId,
      nodeId: row.nodeId,
      version: row.version,
      recordId: this.recordId,
      sheetId: this.worksheetId
    }
    const res = await handleCustomTrigger(data)
    if (res.success) {
      this.actionShow = false
      if (!hiddenTip) {
        Toast.success({
          duration: 2000,
          message: row.customTriggerHandledProperty.handledExecuteTip
        })
      }
      if (row.succeededProperty && row.succeededProperty.index === 0) {
        this.$router.replace(`${this.$route.path}?${Math.random()}`)
      } else {
        this.$router.go(-1)
      }
    }
  }
  private onSelect (item) {
    console.log(item)
    if (item.key === 'delete') {
      this.delete()
    } else if (item.key === 'customTrigger') {
      this.customTrigger(item)
    } else if (this.operateType.includes(item.key)) {
      let {applicationId, worksheetId, viewId} = this.$route.params
      if (item.key === 'track') {
        this.$router.push(`/sheet/${this.processId}/${item.key}`)
      } else {
        this.$router.push(`/sheet/${applicationId}/${worksheetId}/${viewId}/${this.recordId}/${item.key}`)
      }
    }
  }
  private customTrigger (item) {
    if (item.customTriggerHandledProperty.index === 1) {
      this.fetchCustomTrigger(item, false)
    } else if (item.customTriggerHandledProperty.index === 2) {
      Dialog.confirm({
        title: '提示',
        message: item.customTriggerHandledProperty.handledExecuteTip,
        confirmButtonText: item.customTriggerHandledProperty.handledConfirmButtonText,
        cancelButtonText: item.customTriggerHandledProperty.handledCancelButtonText,
      }).then(async () => {
        this.fetchCustomTrigger(item, true)
      })
    } else if (item.customTriggerHandledProperty.index === 3) {
      this.triggerBtnForm(item)
      this.actionShow = false
    }
  } 
  private delete () {
    Dialog.confirm({
      title: '删除记录',
      message: '确定删除此记录吗？',
    }).then(async () => {
      let res = await deleteRecord({worksheetId: this.worksheetId, id: this.recordId})
      if (res.success) {
        this.$router.go(-1)
      }
    })
  }
}
